import React from 'react';
import RangeFilterPlain from './shared/RangeFilterPlain/RangeFilterPlain';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';

import css from './SearchPageStyles.module.css';

const DraughtFilter = () => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;

  const currentQueryParams = parse(location?.search);

  return (
    <RangeFilterPlain
      className={css.draughtFilter}
      id="draughtFilter"
      label={intl.formatMessage({ id: 'Global.draught' })}
      queryParamNames={'draught'}
      initialValues={{ draught: currentQueryParams.draught }}
      min={0}
      max={1000}
      unit="m"
      disableMin
      showTrigger={false}
      liveEdit={true}
      compactFilter
    />
  );
};

export default DraughtFilter;
